import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { Button } from 'reactstrap';
import moment from 'moment';
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import FloatingControls from '../../components/FloatingControls';
import FormPageLayout from '../../components/FormPageLayout';
import LoadingOverlay from '../../components/LoadingOverlay';
import ErrorToast from '../../ErrorToast';
import { displayError } from '../../helpers';
import { getUserAllowedPlants } from '../../services/PlantServices';
import { getAllEquipments } from '../../services/EquipmentServices';
import { getAllVendors } from '../../services/VendorServices';
import { createMaintenanceService } from '../../services/MaintenanceServices';
import MaintenanceServiceForm from './MaintenanceServiceForm';
import {
    buildServiceFormData,
    defaultServiceInputs,
    emptySparePartLine,
} from './maintenanceServiceConstants';

function PreventiveMaintenance() {
    const [cookies] = useCookies(['myToken']);
    const navigate = useNavigate();
    const [plants, setPlants] = useState([]);
    const [equipments, setEquipments] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [inProgress, setInProgress] = useState(false);
    const [inputs, setInputs] = useState({
        ...defaultServiceInputs(),
        service_date: moment().format('DD-MM-YYYY'),
    });
    const [spareParts, setSpareParts] = useState([emptySparePartLine(1)]);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [clearFiles, setClearFiles] = useState({ bill: false, report: false });

    useEffect(() => {
        getUserAllowedPlants(cookies).then((response) => {
            setPlants((response.plant_list || []).filter((p) => p.status).map((p) => ({ value: p.id, label: p.plant_alias })));
        });
        getAllEquipments(cookies).then((response) => {
            setEquipments((response.equipment_list || []).filter((e) => e.status === true || e.status === 1 || e.status === 'Active'));
        });
        getAllVendors(cookies).then((response) => {
            setVendors(response.vendor_list || response.vendors || []);
        });
    }, [cookies]);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!inputs.plant_id || !inputs.equipment_id) {
            Swal.fire('Plant and equipment are required.');
            return;
        }
        setInProgress(true);
        const payload = buildServiceFormData(inputs, spareParts, selectedFiles, {
            clear_bill_file: clearFiles.bill,
            clear_service_report_file: clearFiles.report,
        });
        createMaintenanceService(cookies, payload)
            .then((response) => {
                Swal.fire({ icon: 'success', title: 'Service record saved' }).then(() => {
                    navigate(`/PreventiveMaintenanceEdit/${response.id}`);
                });
            })
            .catch((error) => displayError(error?.response?.data || error, 'Save Failed'))
            .finally(() => setInProgress(false));
    };

    return (
        <div id="outer-container" className="App">
            <Sidebar pageWrapId="page-wrap" outerContainerId="outer-container" />
            <ErrorToast />
            <LoadingOverlay active={inProgress} />
            <div id="page-wrap">
                <form onSubmit={handleSubmit}>
                    <FloatingControls tableLink="/PreventiveMaintenanceTable" formLink="/PreventiveMaintenance" addNewLabel="Main Form" enableCancel onCancel={() => navigate('/PreventiveMaintenanceTable')} />
                    <FormPageLayout moduleLabel="MAINTENANCE" title="Service & Breakdown Record" subtitle="Preventive maintenance schedule, breakdown details, spare parts, vendor bills and service reports." modeLabel="CREATE MODE">
                        <MaintenanceServiceForm cookies={cookies} plants={plants} equipments={equipments} vendors={vendors} inputs={inputs} setInputs={setInputs} spareParts={spareParts} setSpareParts={setSpareParts} selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} clearFiles={clearFiles} setClearFiles={setClearFiles} />
                        <div className="text-right mb-4 px-3">
                            <Button color="primary" type="submit">Save Service Record</Button>
                        </div>
                    </FormPageLayout>
                </form>
            </div>
        </div>
    );
}

export default PreventiveMaintenance;
